import moment from 'moment';
import SgSessionStorageService from 'sg-session-storage';
import { SgDateUtil } from 'saga-modules';

export default (LocaleService) => {
    return {
        optionalVisibility: (cond, target) => {
            return cond ? target : 'OPTIONAL';
        },
        belongsToFilter: (value, filterName) => {
            return value && value.typelist.getFilter(filterName)
                .allows(value);
        },
        hasCategory: (value, parent) => {
            if (!parent) {
                return false;
            }

            return value.belongsToCategory(parent);
        },
        getContextValue: (context, prop) => {
            return context(prop);
        },
        matchesPattern: (pattern, value) => {
            return !pattern || !value || new RegExp(`^${pattern}$`).test(value);
        },
        typekeyIn: (tk, values) => {
            return values.indexOf(tk.code) >= 0;
        },
        range: (l, r, m) => {
            return l <= m && m <= r;
        },
        decimalRange: (l, r, m) => {
            return l <= m && m <= r;
        },
        strLength: (s) => {
            return s ? s.length : 0;
        },
        arrLength: (a) => {
            return a ? a.length : 0;
        },
        getFromMap: (m, k) => {
            return m[k];
        },
        compareDate: (d1, d2) => {
            return new Date(d1).getTime() - new Date(d2).getTime();
        },
        isEmpty: (s1) => {
            return !s1 || s1.length === 0;
        },
        isCurrency: (obj) => {
            if (obj === undefined || obj === null || obj === '') {
                return false;
            }

            if (typeof obj === 'number') {
                // eslint-disable-next-line no-param-reassign
                obj = obj.toString();
            }

            if (typeof obj !== 'string') {
                return false;
            }

            if (!obj.match(/^\d*(.\d*)?$/)) {
                return false;
            }

            const currencyInfo = LocaleService
                ? LocaleService.getLocaleInfo().currency
                : { fractionSize: 2 };
            return obj.indexOf('.') === -1 || obj.indexOf('.') >= obj.length - (currencyInfo.fractionSize + 1);
        },
        // saga added
        intToString: (str) => {
            let val = str;
            if (!val) {
                return false;
            }

            if (typeof val === 'number') {
                val = val.toString();
            }

            return val;
        },
        matchesDatePattern_Ext: (pattern, d, m, y) => {
            let day = d;
            let month = m;
            let year = y;
            if (day === undefined || day === null || day === '') {
                return false;
            }
            if (month === undefined || month === null || month === '') {
                return false;
            }
            if (year === undefined || year === null || year === '') {
                return false;
            }

            if (typeof day === 'number') {
                day = d.toString();
            }
            if (typeof month === 'number') {
                month = month.toString();
            }
            if (typeof year === 'number') {
                year = year.toString();
            }
            if (day.length === 1) {
                day = `0${day}`;
            }
            if (month.length === 1) {
                month = `0${month}`;
            }
            const dateString = day.concat(month).concat(year);

            return !pattern || !dateString || new RegExp(`^${pattern}$`).test(dateString);
        },
        chooseTypeKey: (condition, trueVal, falseVal) => {
            return condition ? trueVal : falseVal;
        },
        getPercentageValue: (val1, val2) => {
            return (val1 / val2) * 100;
        },
        isSingleTripInEurope: () => {
            return SgSessionStorageService.getItem(SgSessionStorageService.KEY.SPT_HAS_ONLY_EUROPEAN_COUNTRIES) === 'true';
        },
        isSingleTripInUK: () => {
            return SgSessionStorageService.getItem(SgSessionStorageService.KEY.SPT_HAS_ONLY_UK_TRIP) === 'true';
        },
        getPmiMaxCoverDate: () => {
            return SgSessionStorageService.getItem(SgSessionStorageService.KEY.MAX_START_DATE);
        },
        isDateValid_Ext: (dateDto) => {
            return SgDateUtil.dateIsValid(dateDto);
        }
    };
};
